import Quantity from './quantity'

export default Quantity
